<template>
    <iframe :src="registrationSource" frameborder="0"></iframe>
</template>
<script>
  import swal from 'sweetalert2'
  import axios from 'axios'

export default {
    name: 'unit-number-search-page',
    data(){
        return{
            registrationSource: './static/api/201Form/201Form.php?unitNumber='+this.$route.params.unitNumber
        }
    },
    mounted () {
        //window.location = this.registrationSource
    }
}
</script>
<style scoped>
html, body{
            margin: 0;
            height: 100%;
            overflow: hidden;
        }
    iframe{
            width:100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
.routerView{
    padding: 0
}
</style>




// WEBPACK FOOTER //
// src/components/unitSearchPage.vue